export default {
  refer: '/user/profile',
};
